// Components
import Skeleton from '@mui/material/Skeleton';

// Styles
import styles from './index.module.sass';

export default function LoadingMenu() {
  const menuArray = Array(10).fill(0);

  return (
    <div className={`${styles.loadingMenu}`}>
      <div className={styles.loadingGrid}>
        {menuArray.map((val, key) => {
          return (
            <Skeleton variant='rectangular' animation='wave' className={styles.item} key={key} />
          );
        })}
      </div>
    </div>
  );
}
